import { Box, type BoxProps } from "@hightouch/htui";

import { NATIVE_DELIVERY_ICON_PATH } from "src/ui/icons/native-delivery";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d={NATIVE_DELIVERY_ICON_PATH}
      clipRule="evenodd"
    />
  </Box>
);
